import React from 'react';
import styles from './Table.module.scss';

const Thead = ({ children, ...props }) => {
  return (
    <thead className={styles.Thead} {...props}>
      {children}
    </thead>
  );
};

export default Thead;
